import { ReactComponent as BulbIcon } from "assets/BulbIconSmall.svg";
import { ReactComponent as CopyIcon } from "assets/CopyIcon.svg";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "assets/EditIcon.svg";
import { ReactComponent as Export } from "assets/Export.svg";
import { ReactComponent as PinIcon } from "assets/PinIconSmall.svg";
import { ReactComponent as UnPinIcon } from "assets/UnPinIconSmall.svg";
import { exportURLs } from "components/common/Export/ExportAPIEndpoints";
import {
  duplicateFilter,
  setStaticPropertyInfo,
  updateCorpSavedFilters,
  updateCorpSavedFiltersConsultant
} from "components/common/Filters/Filters.slice";
import { filterPage } from "components/common/Filters/FiltersHelper";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import { setStaticListId } from "components/features/ManageSuggestions/ManageSuggestions.slice";
import { store } from "redux/store";
import { corpViewTypes } from "utils/CommonConstants";
import { editList, fileExportHandler, formFilterRequestPayload } from "utils/CommonFunctions";
import { recommendationAccessTypes, serviceTypes } from "utils/Types";
import { routes } from "utils/routes";
import { setDialog, setSelectedList, setSelectedListCategory } from "../Corp/CorpUser.Slice";

export const searchInMyLists = (element: any, list: any) => {
  const listData = [];
  for (let section of list) {
    const searchedData = section?.data?.filter((e: any) => e.name?.toLowerCase()?.includes(element?.toLowerCase()));
    if (searchedData?.length) listData.push({ ...section, data: searchedData });
  }
  return listData;
};

export const getmyListType = (listType: string, listName: string) => {
  if (listType === "bookmarked") {
    return listName === "Bookmarked Plans" ? "bookmarked_plans" : "bookmarked_properties";
  }
  return listType;
};

const duplicateList = async (val: any, dispatch: any, listType: string, toFilterType: string) => {
  const fromFilter = val.name === "Bookmarked Properties" ? "bookmarkedProperties" : "bookmarkedPlans";
  const fromFilterType = listType === "bookmarked" ? fromFilter : listType;
  const payload = {
    fromFilterType,
    fromFilterId: val.id ?? "0",
    toFilterType,
    name: `Copy of ${val.name}`,
    description: val.description
  };
  const response = await dispatch(duplicateFilter(payload));
  const duplicatedList = response.payload[toFilterType]?.find((element: any) => element.name === `Copy of ${val.name}`);

  dispatch(
    setPageFilter({
      pageName: filterPage.listDisplay,
      defaultFilter: duplicatedList.filters || [],
      modifiedFilter: []
    })
  );
  dispatch(setSelectedList(duplicatedList));
  dispatch(setSelectedListCategory(toFilterType));
};

const getDuplicateAsOptions = (isConsultant: boolean, dispatch: any, listType: string) => {
  let options = [
    {
      key: "saved_property_list",
      label: "Duplicate as Saved Property List",
      enabled: true,
      icon: CopyIcon,
      action: (val: any) => duplicateList(val, dispatch, listType, "static")
    }
  ];

  if (listType === "dynamic") {
    options = [
      {
        key: "saved_filters",
        label: "Duplicate as Saved Filters",
        enabled: true,
        icon: CopyIcon,
        action: (val: any) => duplicateList(val, dispatch, listType, "dynamic")
      },
      ...options
    ];
  }

  if (isConsultant) {
    options = [
      ...options,
      {
        key: "consultant_list",
        label: "Duplicate as Consultant List",
        enabled: true,
        icon: CopyIcon,
        action: (val: any) => duplicateList(val, dispatch, listType, "consultant")
      }
    ];
  }

  return options;
};

export const getListData = (isConsultant: boolean, dispatch: any, savedFiltersAndLists: any, navigate: any) => {
  const state: any = store.getState();

  const updateMyLists = (listType: string, subList: any, updatedVal: {}) => {
    if (listType === "consultant") {
      const payloadData = { ...updatedVal };
      dispatch(updateCorpSavedFiltersConsultant({ payload: payloadData, listId: subList?.id }));
    } else {
      let payload: { [key: string]: any } = {};
      payload[listType] = [{ ...subList, ...updatedVal }];
      dispatch(updateCorpSavedFilters(payload));
    }
  };
  const downloadURL = exportURLs.corp_properties;
  const pinUnPinMenus = (listType: string) => {
    return [
      {
        label: "Pin to top",
        icon: PinIcon,
        enabled: true,
        action: (val: any) => updateMyLists(listType, val, { isFlagged: val?.isFlagged === "Y" ? "N" : "Y" })
      },
      {
        label: "Unpin from top",
        icon: UnPinIcon,
        enabled: true,
        action: (val: any) => updateMyLists(listType, val, { isFlagged: val?.isFlagged === "Y" ? "N" : "Y" })
      }
    ];
  };

  const listDetails = [
    {
      label: "Bookmarked",
      id: 0,
      listType: "bookmarked",
      data: savedFiltersAndLists?.["bookmarked"],
      menu: [
        {
          label: "Export",
          icon: Export,
          enabled: true,
          action: (val: any) => {
            const data = {
              view: corpViewTypes.myList,
              myListType: getmyListType("bookmarked", val.name),
              myListId: val.id
            };
            fileExportHandler(downloadURL, serviceTypes.userplan, data);
          }
        },
        {
          label: "Duplicate",
          icon: CopyIcon,
          enabled: true,
          subMenu: getDuplicateAsOptions(isConsultant, dispatch, "bookmarked")
        }
      ]
    },
    {
      label: "Saved Filters",
      id: 1,
      listType: "dynamic",
      data: savedFiltersAndLists?.["dynamic"],
      menu: [
        {
          label: "Rename",
          icon: EditIcon,
          enabled: true,
          action: (val: any) => dispatch(setDialog({ dialogName: "renameList", isOpen: true, data: val }))
        },
        {
          label: "Export",
          icon: Export,
          enabled: true,
          action: (val: any) => {
            const data = {
              ...formFilterRequestPayload(val.filters),
              view: corpViewTypes.myList,
              myListType: "dynamic",
              myListId: val.id
            };
            fileExportHandler(downloadURL, serviceTypes.userplan, data);
          }
        },
        {
          label: "Duplicate",
          icon: CopyIcon,
          enabled: true,
          subMenu: getDuplicateAsOptions(isConsultant, dispatch, "dynamic")
        },
        {
          label: "Delete",
          icon: DeleteIcon,
          enabled: true,
          action: (val: any) =>
            dispatch(setDialog({ dialogName: "deleteList", isOpen: true, data: val, listType: "dynamic" }))
        },
        ...pinUnPinMenus("dynamic")
      ]
    },
    {
      label: "Saved Property Lists",
      id: 2,
      listType: "static",
      data: savedFiltersAndLists?.["static"],
      menu: [
        {
          label: "Edit",
          icon: EditIcon,
          enabled: true,
          action: (val: any) => editList(val, "static")
        },
        {
          label: "Export",
          icon: Export,
          enabled: true,
          action: (val: any) => {
            const data = {
              view: corpViewTypes.myList,
              myListType: "static",
              myListId: val.id
            };
            fileExportHandler(downloadURL, serviceTypes.userplan, data);
          }
        },
        {
          label: "Duplicate",
          icon: CopyIcon,
          enabled: true,
          subMenu: getDuplicateAsOptions(isConsultant, dispatch, "static")
        },
        {
          label: "Delete",
          icon: DeleteIcon,
          enabled: true,
          action: (val: any) =>
            dispatch(setDialog({ dialogName: "deleteList", isOpen: true, data: val, listType: "static" }))
        },
        ...pinUnPinMenus("static")
      ]
    },
    {
      label: "Consultant Lists",
      id: 3,
      listType: "consultant",
      data: savedFiltersAndLists?.["consultant"],
      menu: [
        { label: "Edit", icon: EditIcon, enabled: true, action: (val: any) => editList(val, "sc") },
        {
          label: "Export",
          icon: Export,
          enabled: true,
          action: (val: any) => {
            const data = {
              view: corpViewTypes.myList,
              myListType: "consultant",
              myListId: val.id
            };
            fileExportHandler(downloadURL, serviceTypes.userplan, data);
          }
        },
        {
          label: "Duplicate",
          icon: CopyIcon,
          enabled: true,
          subMenu: getDuplicateAsOptions(isConsultant, dispatch, "consultant")
        },
        {
          label: "Delete",
          icon: DeleteIcon,
          enabled: true,
          action: (val: any) => dispatch(setDialog({ dialogName: "deleteSCList", isOpen: true, data: val }))
        },
        ...pinUnPinMenus("consultant")
      ]
    }
  ];

  if (
    state.app.loggedInUserDetails.uploadRecommendationAccess === recommendationAccessTypes.edit ||
    state.app.loggedInUserDetails.uploadRecommendationAccess === recommendationAccessTypes.upload
  ) {
    const elementToInsert: any = {
      label: "Add Suggested Plan(s)",
      icon: BulbIcon,
      enabled: true,
      action: (val: any) => {
        const optionId = [val.id];
        dispatch(setStaticListId(val?.id));
        dispatch(
          setPageFilter({
            pageName: filterPage.manageSuggestionsDisplay,
            modifiedFilter: [
              {
                id: 31,
                options: optionId,
                key: "staticListIds",
                name: "My Property Lists"
              }
            ]
          })
        );
        dispatch(setStaticPropertyInfo({ id: val.id, name: val?.name }));
        navigate(routes.ManageSuggestions, {
          state: {
            redirectedFrom: "myList"
          }
        });
      }
    };
    listDetails[2]["menu"].splice(2, 0, elementToInsert);
  }

  if (state.app.loggedInUserDetails.isAbovePropertyUser) {
    return listDetails
      .filter((item) => item.listType === "static")
      .map((item) => ({
        ...item,
        menu: item.menu.filter((menuItem: any) => ["Edit", "Export", "Delete"].includes(menuItem.label))
      }));
  }

  return listDetails;
};

export const getAllBreakupLists = (statusBreakUp: any, showNotStarted: boolean = false) => {
  if (statusBreakUp) {
    let list = [
      { name: "New", value: statusBreakUp?.["New"], isShowStar: statusBreakUp["newOverDue"] > 0 },
      {
        name: "In Progress",
        value: statusBreakUp?.["In Progress"],
        isShowStar: statusBreakUp?.["inProgressOverDue"] > 0
      },
      { name: "Completed", value: statusBreakUp["Completed"], isShowStar: false }
    ];
    if (showNotStarted) {
      // list = [...list, { name: "Not Started", value: statusBreakUp["Not Started"], isShowStar: false }];
      list.unshift({ name: "Not Started", value: statusBreakUp["Not Started"], isShowStar: false });
    }
    return list;
  }
  return null;
};
